import * as dateFns from 'date-fns' 

export const dateWithoutTZ = date => dateFns.addMinutes(date, date.getTimezoneOffset());

export const format = date => dateFns.format(dateWithoutTZ(new Date(date)), 'yyyy-MM-dd');
export const formatDate = date => dateFns.format(dateWithoutTZ(date), 'yyyy-MM-dd');